import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ne784f3jf: FaireProductEntity = {
  token: "p_7ne784f3jf",
  type: "product",
  name: "Espresso Martini Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/0fdf5354a58c141f1a33c4c3317bcf30fe390d26beafcfd57edd482421309128.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2741bb8d5f18e881e3a53b524b2a566f324e4b864db1ec1a3fb64f103d416ee7.jpeg",
    "https://cdn.faire.com/fastly/938cdbef12ca81e6761009d4acf8a0ef08dab75cb29a211f4993881b1d3949b7.jpeg",
    "https://cdn.faire.com/fastly/af01276bb8debaad88ea088ba149b0624cf12c0af82a5e5ad6cb548b7326303d.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:49.177Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
